import { Grid, Typography } from '@mui/material';

import { BffWorkingHours } from '@/types/generated';
import { getLocalTimeFromTimeZone } from '@/utils/getLocalTimeFromTimeZone';

import { getNextOpenTime, getTodayCloseTime, isOfficeOpen } from './LocationStatus.helpers';

export interface ILocationStatus {
	bffWorkingHours: BffWorkingHours[];
	holidayHoursMessageText?: string;
	timeZoneId?: string;
}

export default function LocationStatus({ bffWorkingHours, holidayHoursMessageText, timeZoneId }: ILocationStatus) {
	const localCurrenTimeDetails = getLocalTimeFromTimeZone(timeZoneId || '');

	const { localDayOfWeek, localTime, localAmOrPm } = localCurrenTimeDetails;
	const hours = bffWorkingHours?.filter((hour) => hour.date === localDayOfWeek);
	const isOfficeOpenNow = isOfficeOpen(hours, localTime, localAmOrPm);
	const closeTime = getTodayCloseTime(hours);
	const nextOpenTime = getNextOpenTime(localDayOfWeek, bffWorkingHours, localAmOrPm);
	const shouldShowWorkingHours = closeTime || nextOpenTime;

	return (
		<Grid container>
			{shouldShowWorkingHours && (
				<Grid item container gap={0.5} justifyContent="left" data-test-id="location-status-section">
					<Grid item>
						{isOfficeOpenNow ? (
							<Typography
								variant="bodySmallBold"
								color="success.dark"
								data-test-id="location-status-current-open"
							>
								Open &middot;
							</Typography>
						) : (
							<Typography
								variant="bodySmallBold"
								color="error.dark"
								data-test-id="location-status-current-closed"
							>
								Closed &middot;
							</Typography>
						)}
					</Grid>
					<Grid item>
						{isOfficeOpenNow ? (
							<Typography
								variant="bodySmallBook"
								color="text.primary"
								data-test-id="location-status-current-open-text"
							>
								Closes at {closeTime}
							</Typography>
						) : nextOpenTime ? (
							<Typography
								variant="bodySmallBook"
								color="text.primary"
								data-test-id="location-status-current-closed-text"
							>
								Opens at {nextOpenTime}
							</Typography>
						) : null}
					</Grid>
				</Grid>
			)}
			{holidayHoursMessageText && (
				<Grid
					item
					container
					justifyContent="left"
					sx={{ paddingBottom: 1 }}
					data-test-id="location-status-holiday-text"
				>
					<Typography variant="lowestLevelBook" color="text.tertiary">
						{holidayHoursMessageText}
					</Typography>
				</Grid>
			)}
		</Grid>
	);
}
